<script lang="ts" setup>
import MImageLoader from '@/components/molecules/forms/ImageLoader.vue'
import ADecorMobileEllipse2 from '~/components/atoms/decor/MobileEllipse2.vue'
import ADecorEllipse2 from '~/components/atoms/decor/Ellipse2.vue'
import ADecorEllipse3 from '~/components/atoms/decor/Ellipse3.vue'
import ADecorEllipse4 from '~/components/atoms/decor/Ellipse4.vue'
import ADecorEllipse5 from '~/components/atoms/decor/Ellipse5.vue'

const emit = defineEmits<{
  (e: 'image-selected', file: File): void
}>()

const changeImage = (file: File): void => {
  emit('image-selected', file)
}
</script>

<template>
  <section class="advantages">
    <div class="container-lg">
      <h2 class="advantages__title">
        Преимущества Магви
      </h2>
      <div class="row feature">
        <div class="col-12 col-lg-4 col-xl-3">
          <h3 class="feature__title">
            Нейросеть для&nbsp;создания фона товара
          </h3>
          <p class="mb-2">
            Искусственный интеллект удалит и создаст фон под ваш запрос. 
            Товары могут выглядеть как после профессиональной съёмки
          </p>
          <MImageLoader
            v-slot="scope"
            @change="changeImage"
          >
            <button
              @click="scope.loadImage"
              class="d-flex align-items-center btn btn-link p-0 custom-link btn-arrow mb-4 mb-lg-0"
            >
              Загрузить фото товара
              <BootstrapIconChevronRight class="ms-1" />
            </button>
          </MImageLoader>
        </div>
        <div class="col-12 col-lg-8 col-xl-9 position-relative">
          <NuxtImg
            format="webp"
            src="/home/feature/feature-1.webp"
            alt="Интерфейс Магви генерации фона для карточки товара рюказака в горах"
            class="feature__img"
            sizes="453px 479px:722px 767px:946px 991px:614px 1199px:829px 1399px:964px"
            fetchpriority="low"
            loading="lazy"
            densities="x1 x2"
            width="1662"
            height="946"
            style="height: auto; aspect-ratio: 1662 / 946;"
          />
          <div class="a-ellipse-1">
            <ADecorEllipse2 class="d-none d-md-block" />
            <ADecorMobileEllipse2 class="d-md-none" />
          </div>
        </div>
      </div>
      <div class="row feature">
        <div class="col-12 col-lg-8 col-xl-9 order-1 order-lg-0 position-relative">
          <NuxtImg
            format="webp"
            src="/home/feature/feature-2.webp"
            alt="Интерфейс редактора Magvi c настройкой цвета шрифта"
            class="feature__img mb-3 mb-lg-0"
            sizes="453px 479px:722px 767px:946px 991px:614px 1199px:829px 1399px:964px"
            fetchpriority="low"
            loading="lazy"
            densities="x1 x2"
            width="1662"
            height="946"
            style="height: auto; aspect-ratio: 1662 / 946;"
          />
          <div class="d-flex d-lg-none gap-4">
            <div>
              <p class="head4 mb-0">
                5 000 000
              </p>
              <p class="mb-0">
                Иконок
              </p>
            </div>
            <div>
              <p class="head4 mb-0">
                219
              </p>
              <p class="mb-0">
                Шрифтов
              </p>
            </div>
          </div>
          <div class="a-ellipse-2">
            <ADecorEllipse3 class="d-none d-xl-block" />
            <ADecorEllipse2 class="d-none d-md-block d-xl-none" />
            <ADecorMobileEllipse2 class="d-md-none" />
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3">
          <div class="feature__info">
            <div>
              <h2 class="feature__title">
                Удобный редактор
              </h2>
              <p class="mb-2">
                Самостоятельно измените цвет любых элементов, подчеркните преимущества товара при помощи иконок 
                и&nbsp;выберите подходящий шрифт
              </p>
              <MImageLoader
                v-slot="scope"
                @change="changeImage"
              >
                <button
                  @click="scope.loadImage"
                  class="d-flex align-items-center btn btn-link p-0 custom-link btn-arrow mb-4 mb-lg-0"
                >
                  Загрузить фото
                  товара
                  <BootstrapIconChevronRight class="ms-1" />
                </button>
              </MImageLoader>
            </div>
            <div class="d-none d-lg-block">
              <p class="head4 mb-0">
                5 000 000
              </p>
              <p>
                Иконок
              </p>
              <p class="head4 mb-0">
                219
              </p>
              <p class="mb-0">
                Шрифтов
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row feature">
        <div class="col-12 col-lg-4 col-xl-3">
          <div class="feature__info">
            <div>
              <h3 class="feature__title">
                Готовые шаблоны
              </h3>
              <p class="mb-2">
                Создайте инфографику для маркетплейсов Wildberries, Ozon, Яндекс Маркета и&nbsp;других за 
                считанные минуты
              </p>
              <NuxtLink
                to="/templates"
                class="d-flex align-items-center custom-link btn-arrow mb-4 mb-lg-0"
              >
                Выбрать шаблон
                <BootstrapIconChevronRight class="ms-1" />
              </NuxtLink>
            </div>
            <div class="d-none d-lg-block">
              <p class="head4 mb-0">
                36
              </p>
              <p class="mb-0">
                Шаблонов для<br>карточек 3:4
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8 col-xl-9 position-relative">
          <NuxtImg
            format="webp"
            src="/home/feature/feature-3.webp"
            alt="Страница Магви с шаблонами карточек с инфографикой для маркетплейсов"
            class="feature__img mb-3 mb-lg-0"
            sizes="453px 479px:722px 767px:946px 991px:614px 1199px:829px 1399px:964px"
            fetchpriority="low"
            loading="lazy"
            densities="x1 x2"
            width="1662"
            height="948"
            style="height: auto; aspect-ratio: 1662 / 948;"
          />
          <div class="d-block d-lg-none">
            <p class="head4 mb-0">
              36
            </p>
            <p class="mb-0">
              Шаблонов для карточек 3:4
            </p>
          </div>
          <div class="a-ellipse-3">
            <ADecorEllipse4 class="d-none d-xl-block" />
            <ADecorEllipse2 class="d-none d-md-block d-xl-none" />
            <ADecorMobileEllipse2 class="d-md-none" />
          </div>
        </div>
      </div>
      <div class="row feature">
        <div class="col-12 col-lg-8 col-xl-9 order-1 order-lg-0 position-relative">
          <NuxtImg
            format="webp"
            src="/home/feature/feature-4.webp"
            alt="Страница Магви c карточками в личном кабинете"
            class="feature__img mb-3 mb-lg-0"
            sizes="453px 479px:722px 767px:946px 991px:614px 1199px:829px 1399px:964px"
            fetchpriority="low"
            loading="lazy"
            densities="x1 x2"
            width="1662"
            height="948"
            style="height: auto; aspect-ratio: 1662 / 948;"
          />
          <div class="d-block d-lg-none">
            <p class="head4 mb-0">
              ∞
            </p>
            <p class="mb-0">
              Бесконечное количество личных шаблонов
            </p>
          </div>
          <div class="a-ellipse-4">
            <ADecorEllipse5 class="d-none d-xl-block" />
            <ADecorEllipse2 class="d-none d-md-block d-xl-none" />
            <ADecorMobileEllipse2 class="d-md-none" />
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3">
          <div class="feature__info">
            <div>
              <h2 class="feature__title">
                Ваши шаблоны
              </h2>
              <p class="mb-2">
                Сохраняйте обложки товаров в&nbsp;профиле и экспериментируйте для роста продаж 
              </p>
              <MImageLoader
                v-slot="scope"
                @change="changeImage"
              >
                <button
                  @click="scope.loadImage"
                  class="d-flex align-items-center btn btn-link p-0 custom-link btn-arrow mb-4 mb-lg-0"
                >
                  Загрузить фото товара
                  <BootstrapIconChevronRight class="ms-1" />
                </button>
              </MImageLoader>
            </div>
            <div class="d-none d-lg-block">
              <p class="head4 mb-0">
                ∞
              </p>
              <p class="mb-0">
                Бесконечное количество<br> личных шаблонов
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.advantages {
  padding: rem(70px) 0;

  @include media-breakpoint-down(lg) {
    padding: rem(60px) 0;
  }

  &__title {
    font-size: rem(28px);
    line-height: 120%;
    margin-bottom: rem(48px);

    @include media-breakpoint-up(md) {
      font-size: rem(40px);
    }
    
    @include media-breakpoint-up(lg) {
      text-align: center;
    }
  }
}

.feature {  
  position: relative;

  &:not(:last-child) {
    margin-bottom: rem(120px);

    @include media-breakpoint-down(lg) {
      margin-bottom: rem(56px);
    }
  }

  &__title {
    margin-bottom: rem(12px);
    font-size: rem(32px);

    @include media-breakpoint-down(md) {
      font-size: rem(20px);
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  &__img {
    border: 1px solid $gray-300;
    border-radius: rem(4px);
    width: 100%;
  }
}

.a-ellipse-1 {
  position: absolute;
  width: 441px;
  height: 455px;
  top: -154px;
  right: -125px;
  z-index: -1;
  padding: 0;

  @include media-breakpoint-up(md) {
    width: 996px;
    height: 1027px;
    top: -320px;
    right: -317px;
  }
  
  @include media-breakpoint-up(xl) {
    top: -339px;
    right: -270px;
  }
}

.a-ellipse-2 {
  position: absolute;
  width: 441px;
  height: 455px;
  top: -120px;
  right: -112px;
  z-index: -1;
  padding: 0;

  @include media-breakpoint-up(md) {
    width: 996px;
    height: 1027px;
    top: -321px;
    left: -305px;
    right: auto;
  }
  
  @include media-breakpoint-up(xl) {
    width: 991px;
    height: 1021px;
    top: -323px;
    left: -313px;
  }
}

.a-ellipse-3 {
  position: absolute;
  width: 441px;
  height: 455px;
  top: -115px;
  right: -112px;
  z-index: -1;
  padding: 0;

  @include media-breakpoint-up(md) {
    width: 996px;
    height: 1027px;
    top: -277px;
    right: -299px;
  }
  
  @include media-breakpoint-up(xl) {
    width: 997px;
    height: 977px;
    top: -373px;
    right: -361px;
  }
}

.a-ellipse-4 {
  position: absolute;
  width: 441px;
  height: 455px;
  top: -115px;
  right: -111px;
  z-index: -1;
  padding: 0;

  @include media-breakpoint-up(md) {
    width: 996px;
    height: 1027px;
    top: -290px;
    right: auto;
    left: -297px;
  }
  
  @include media-breakpoint-up(xl) {
    width: 997px;
    height: 1005px;
    top: -320px;
    left: -326px;
  }
}
</style>
